/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Pending_HoldsInputs */

const en_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending holds`)
};

const es_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin retenciones pendientes`)
};

const fr_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune attente en cours`)
};

const de_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine ausstehenden Einbehaltungen`)
};

const ja_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留中の資金はありません`)
};

const zh_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无待处理的冻结资金`)
};

const ar_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مبالغ قيد الاحتجاز`)
};

const id_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada penahanan tertunda`)
};

const it_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun fondo bloccato`)
};

const ru_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет ожидающих заморозок`)
};

const pt_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma retenção pendente`)
};

const ko_no_pending_holds = /** @type {(inputs: No_Pending_HoldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보류 중인 금액 없음`)
};

/**
* | output |
* | --- |
* | "No pending holds" |
*
* @param {No_Pending_HoldsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_pending_holds = /** @type {((inputs?: No_Pending_HoldsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Pending_HoldsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_pending_holds(inputs)
	if (locale === "es") return es_no_pending_holds(inputs)
	if (locale === "fr") return fr_no_pending_holds(inputs)
	if (locale === "de") return de_no_pending_holds(inputs)
	if (locale === "ja") return ja_no_pending_holds(inputs)
	if (locale === "zh") return zh_no_pending_holds(inputs)
	if (locale === "ar") return ar_no_pending_holds(inputs)
	if (locale === "id") return id_no_pending_holds(inputs)
	if (locale === "it") return it_no_pending_holds(inputs)
	if (locale === "ru") return ru_no_pending_holds(inputs)
	if (locale === "pt") return pt_no_pending_holds(inputs)
	return ko_no_pending_holds(inputs)
});